<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.mealPlanNav.overview')" link="mealPlans" />
    <item-nav-group v-if="!isEmpty(mealPlans)" :open="true" :label="$t('layout.nav.admin.mealPlanNav.mealPlans')">
      <template v-for="mealPlan in mealPlans" v-if="!mealPlan.deleted">
        <item-nav-group-item :label="getName(mealPlan.name)" :params="routeParams(mealPlan.id)" :key="mealPlan.id" link="mealPlan" />
      </template>
    </item-nav-group>

    <item-nav-group v-if="!isEmpty(deletedMealPlans)" :label="$t('layout.nav.admin.mealPlanNav.deletedMealPlans')">
      <item-nav-group-item v-for="mealPlan in deletedMealPlans"
                           :label="getName(mealPlan.name)"
                           :params="routeParams(mealPlan.id)"
                           :key="mealPlan.id"
                           link="mealPlan" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, keyBy, sortBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'MealPlanNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      mealPlans: [],
    };
  },

  computed: {
    deletedMealPlans: function () {
      return this.mealPlans.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.updateMealPlans();

    this.$serviceBus.$on('mealPlan.list', (data) => {
      if (isNil(data)) {
        this.updateMealPlans();
      } else {
        this.mealPlans = sortBy(data, ['sort', 'mealPlanType', `name.${this.hotelSettings.details.primaryLanguage}`]);
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    updateMealPlans() {
      this.axios.get(this.serviceUrls.mealPlan.list(this))
        .then((response) => {
          this.mealPlans = sortBy(response.data.data, ['sort', 'mealPlanType', `name.${this.hotelSettings.details.primaryLanguage}`]);
        });
    },
    getName(name) {
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeParams(mealPlanId) {
      return {
        mealPlanId: mealPlanId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/MealPlanNav.vue